import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ChatBot from "./Biggbarains/ChatBot";

const ClientCard = ({ client }) => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const navigate = useNavigate();

  // Toggle the chatbot visibility
  const handleChatClick = () => {
    setIsChatOpen(!isChatOpen);
  };

  const handleProfile = () => {
    const serializableClient = {
      id: client.id,
      name: client.name,
      position: client.position,
      department: client.department,
      email: client.email,
      image: client.image,
      details: client.details,
    };
  
    navigate("/customer/clientprofile", { state: { client: serializableClient } });
  };

  const handleCloseChat = () => {
    setIsChatOpen(false);
  };

  return (
    <div style={styles.card}>
      <div style={styles.imageContainer}>
        <img src={client.image} alt={client.name} style={styles.image} />
        <div style={styles.iconContainer}>
          <p style={styles.icon}>{client.icon2}</p>
          <p style={styles.icon}>{client.icon}</p>
        </div>
      </div>
      <div style={styles.divider}></div>
      <div style={styles.details}>
        <h3 style={styles.name}>{client.name}</h3>
        <p style={styles.position}>{client.position}</p>
        <div style={styles.divider1}></div>
        <p style={styles.brief}>{client.details}</p>

        <div style={styles.buttonContainer}>
          <button style={styles.button} onClick={handleChatClick}>
            Chat
          </button>
          <button style={styles.button} onClick={handleProfile}>
            Profile
          </button>
        </div>
      </div>

      {/* Conditionally render the ChatBot component */}
      {isChatOpen && <ChatBot client={client} closeChat={handleCloseChat} />}
    </div>
  );
};

const styles = {
  card: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '15px',
    padding: '20px',
    margin: '10px',
    backgroundColor: '#ffffff',
    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    cursor: 'pointer',
    width: '90%',
    overflow: 'hidden',
  },
  imageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginRight: '20px',
  },
  image: {
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    objectFit: 'cover',
    marginBottom: '10px',
    backgroundColor: '#f0f0f0',
    padding: '5px',
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    width: 'auto',
    marginTop: '10px',
  },
  icon: {
    width: '30px',
    height: '30px',
    objectFit: 'contain',
    cursor: 'pointer',
  },
  divider: {
    height: '130px',
    width: '1px',
    backgroundColor: '#ddd',
    marginRight: '20px',
  },
  divider1: {
    width: '150%',
    height: '1px',
    backgroundColor: '#ddd',
    margin: '10px 0',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  name: {
    fontSize: '1.2rem',
    fontWeight: '600',
    color: '#2c3e50',
    marginBottom: '10px',
  },
  position: {
    fontSize: '0.7rem',
    color: '#000',
    backgroundColor: "#B9D9EB",
    width: "70%",
  },
  brief: {
    fontSize: '1rem',
    color: '#000',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '10px',
  },
  button: {
    padding: '10px 20px',
    fontSize: '0.9rem',
    backgroundColor: '#2F3B57',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  },
};

export default ClientCard;
